<template>
  <div class="pages" v-loading="listLoading">
    <div
      v-for="(item, index) in templateData.TemplateContent.Controls"
      :key="index"
    >
      <Digit v-if="item.Property.Control === 'Number'" :data-val="item"></Digit>
      <Contact
        v-if="item.Property.Control === 'Condition'"
        :data-val="item"
      ></Contact>
      <DateTime
        v-if="item.Property.Control === 'Date'"
        :data-val="item"
      ></DateTime>
      <Version
        v-if="item.Property.Control === 'Text'"
        @child-event="getTextVal"
        :data-val="item"
      ></Version>
      <Money v-if="item.Property.Control === 'Money'" :data-val="item"></Money>
      <Tips v-if="item.Property.Control === 'Tips'" :data-val="item"></Tips>
      <File v-if="item.Property.Control === 'File'" :data-val="item"></File>
      <Table
        v-if="item.Property.Control === 'Table'"
        @child-event="tableOperation"
        :data-val="item"
      ></Table>
      <Selector
        v-if="item.Property.Control === 'Selector'"
        @child-event="getSelectorVal"
        :data-val="item"
      ></Selector>
      <Textarea
        v-if="item.Property.Control === 'Textarea'"
        :data-val="item"
      ></Textarea>
      <Choose
        v-if="item.Property.Control === 'Contact'"
        @child-event="clickChoose"
        :data-val="item"
      ></Choose>
    </div>
    <Button
      class="submit-process"
      v-on:click="submit"
      v-bind:disabled="isDisabled"
      v-bind:loading="formLoading"
      size="large"
      type="primary"
    >
      提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import DateTime from "../components/Date.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from "../api/jssdk.js";
import { getTemplateInfo, submitProcess } from "@/api/approval";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    DateTime,
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
    };
  },
  created() {
    initWxConfig(this);
    this.logInfo = this.getLoginUserInfo();
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(true);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
        "selectEnterpriseContact",
        {
          fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          mode: "single", // 必填，选择模式，single表示单选，multi表示多选
          type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
          selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        },
        function (res) {
          if (res.err_msg === "selectEnterpriseContact:ok") {
            if (typeof res.result == "string") {
              res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            // 已选的部门列表
            var user = res.result.userList[0];
            dataVal.Values = [];
            dataVal.Values.push([user.id, user.name]);
            dataVal.Value = user.name;
          }
        }
      );
    },
    tableOperation:async function(val, type, datas) {
      this.tableoperation(val, type, datas, this);
    },
    getTextVal() {},
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      const deptName = that.logInfo.DeptName;
      const empName = that.logInfo.EmpName;
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      if(departName.indexOf("房友圈/事业部") === -1
          || jobLevel < 4 ){
        this.Message({
          message: '没有申请权限',
          type: 'error',
          duration: 1000
        });
        this.isDisabled=true;
      }
      getTemplateInfo(this.templateId).then((response) => {
        var controls = response.Body;
        controls.TemplateContent.Controls.forEach((item) => {
          if (item.Property.Title[0].Text === "申请人及组别") {
            item.Value = `${deptName}/${empName}`;
          }
          if (item.Property.Title[0].Text === "项目"){
            let childrens = item.Config.Table.Children;
            childrens.forEach(children => {
              if (children.Property.Title[0].Text === "回款周期"
              ||children.Property.Title[0].Text === "预计成交套数(套)") {
                children.retain = 0;
              }
              if (children.Property.Title[0].Text === "垫佣物业类型"){
                children.ValuesSelectClear = true;
              }
            })
          }
        });
        this.templateData = this.assignControl(controls, this.logInfo);
        this.listLoading = false;
      });
    },
    submit: async function () {
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }
      //申请项目
      let ApplicationItems = [];
      //申请额度
      let ApplicationLimit = [];
      this.templateData.TemplateContent.Controls.forEach(col => {
          if (col.Property.Title[0].Text.indexOf("项目") > -1){
            let childrens = col.Config.Table.Children;
            childrens.forEach(children => {
              if (children.Property.Title[0].Text === "申请项目") {
                ApplicationItems.push(children.Value);
              }
              if (children.Property.Title[0].Text === "申请资金包额度(万元)") {
                ApplicationLimit.push(children.Value);
              }
            })
          }
      })
      var SummaryList = [];
      var info = { SummaryInfo: [] };
      var control1 = "";
      ApplicationItems.forEach((item,index) => {
        if (index !== ApplicationItems.length - 1){
          control1 = `${control1}${item};   `;
        }else {
          control1 = ` ${control1}${item} `;
        }
      })
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请项目："+control1,"Lang":"zh_CN"});
      SummaryList.push(info);
      var control2 = "";
      ApplicationLimit.forEach((item,index) => {
        if (index !== ApplicationItems.length - 1){
          control2 = `${control2}${item};   `;
        }else{
          control2 = ` ${control2}${item} `;
        }
      })
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请额度(万元)："+control2,"Lang":"zh_CN"});
      SummaryList.push(info);

      var data = new Date();
      var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = data.getFullYear() + "-" + month + "-" + date;
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请时间："+dateTime,"Lang":"zh_CN"});
      SummaryList.push(info);
      this.templateData.SummaryList=SummaryList;
      this.isDisabled=true;
      //提交
      submitProcess(
        this.templateId,
        this.logInfo.EmpNo,
        this.spNo,
        this.templateData
      )
        .then((response) => {
          this.Message({
            message: "申请成功",
            type: "success",
            duration: 3 * 1000,
          });
          setTimeout(() => {
            this.$router.push("/index");
          }, 3000);
        })
          .catch(err => {
            this.isDisabled=false;
          })
        .finally(() => {
          isSubmit = false;
          this.listLoading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>